import styled from "styled-components";

export const LogoContainerDefaultBox = styled.div`
  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    margin: 2rem 0 0 0;
    background: transparent;
    padding: 0.7rem 0;
    text-align: center;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
      margin-bottom: 1rem;
    }
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding: 0.25rem 0.5rem;
  }
`;
